import { Icon } from "@blueprintjs/core"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomTag from "components/Atoms/CustomTag"
import TablePagination from "components/Molecules/TablePagination"
import NewResourceButton from "components/Organisms/AddResourceButton"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { DEMAND_CHANGE_PAGE, DEMAND_CHANGE_SEARCH } from "store/demand.redux"
import { RESET_SELECTED } from "store/selector.redux"
import DemandActions from "./DemandActions"
import DemandSearchFilter from "./list/DemandSearchFilter"
const DemandHeader = ({ totalDemands }) => {
  const search = useSelector((state: any) => state.demands.filter.search)
  const page = useSelector((state: any) => state.demands.filter.page)
  const dispatch = useDispatch()
  return (
    <ModuleHeader
      className="bg-white"
      onQueryChange={query => {
        dispatch({
          type: DEMAND_CHANGE_SEARCH,
          payload: query,
        })
        dispatch({
          type: RESET_SELECTED,
          path: "demands",
        })
      }}
      query={search}
      header={
        <>
          <Description icon="cell-tower" title="Demands" />
          {totalDemands ? (
            <CustomTag
              round
              className="ml-2"
              intent="primary"
              minimal
              icon={<Icon icon="chart" iconSize={12} />}
            >
              <span className="vt-highlight"> {totalDemands}</span> Total
            </CustomTag>
          ) : null}
        </>
      }
      filter={<DemandSearchFilter />}
    >
      <DemandActions className="mr-3" totalDemands={totalDemands ?? 0} />
      <TablePagination
        className="mr-3"
        page={page}
        disabledNext={totalDemands > 1 ? false : true}
        onPageChange={page => {
          dispatch({
            type: DEMAND_CHANGE_PAGE,
            payload: page,
          })
        }}
      />

      <NewResourceButton module="demand" />
    </ModuleHeader>
  )
}

export default DemandHeader
